import s from './AscDescBtn.module.css';
import PropTypes from 'prop-types';
import { Descendent } from 'components/iconComponent/Descendent';
import { DescendentActive } from 'components/iconComponent/DescendentActive';
import { Ascendent } from 'components/iconComponent/Ascendent';
import { AscendentActive } from 'components/iconComponent/AscendentActive';
import { useState } from 'react';

const AscDescBtn = ({ onAction }) => {
  const [active, setActive] = useState(true);

  const handlerActive = () => {
    setActive(prev => !prev);
    onAction(active);
  };

  return (
    <div className={s.AscDescBtn}>
      {active ? (
        <div className={s.buttons_block}>
          <DescendentActive onClick={handlerActive} />
          <Ascendent onClick={handlerActive} />
        </div>
      ) : (
        <div className={s.buttons_block}>
          <Descendent onClick={handlerActive} />
          <AscendentActive onClick={handlerActive} />
        </div>
      )}
    </div>
  );
};

export { AscDescBtn };

AscDescBtn.propTypes = {
  onAction: PropTypes.func.isRequired,
};
